import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import Notification from '../../SharedComponents/Notification';
import { AddComplaintStatus } from './ApiComplaints';

export default function FinishComplaint(props) {
  const { t } = useTranslation();
  const { submitId } = useParams();
  const queryClient = useQueryClient();
  const AddComplaintStatusMutation = useMutation(AddComplaintStatus, {
    onSuccess: () => {
      queryClient.refetchQueries('getComplaintBySubmitId');

      toast(<Notification message={t('Complaint Finished')} />);
    },
  });
  const onClick = () => {
    console.log('clicked');
    AddComplaintStatusMutation.mutate({
      complaintStatus: 2,
      submitId: submitId,
    });
  };
  return (
    <button
      onClick={onClick}
      type="button"
      className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded-md"
    >
      {t('Finish')}
    </button>
  );
}
